/**
 * Parses an eCheck payment method into its internal structure.
 *
 * If the payment method does not have an account type, returns null.
 * Otherwise, returns an object with account type, account number, and eCheck suffix.
 *
 * @param paymentMethod The payment method object to be parsed.
 * @returns The internal eCheck structure or null if not applicable.
 */
export const parseEcheckToInternalStructure = paymentMethod => {
  if (!paymentMethod?.accountType) {
    return null;
  }
  return {
    accountType: paymentMethod?.accountType,
    accountNumber: paymentMethod?.accountNumber,
    echeckSuffix: paymentMethod?.echeckSuffix,
  };
};
